<ng-container [formGroup]="form">
    <h2>Opt-In to SMS Notifications</h2>
    <mat-checkbox formControlName="value" color="primary">
        <p>
            To ensure you receive crucial job status updates, Drive & Tow may send you automated SMS text messages. By providing
            your phone number and enabling this option, you consent to receive these messages under Drive & Tow's 
            <span class="link" (click)="onOpenTermsOfUse($event)">Terms of Use</span> and
            <span class="link" (click)="onOpenPrivacyPolicy($event)">Privacy Policy</span>.
        </p>
        <p>
            Standard message and data rates may apply. 
            
            @if (isRegister) {
                You may opt out at any time by updating your preferences in your account screen.
            }
        </p>
    </mat-checkbox>
</ng-container>
